import {
  GetAddCurrencyType,
  GetUpdatedCurrencyDetails,
} from '../../../../../types/Invoicing/Invoices/Settings/addCurrencytype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../utils/apiUtils'
import { AllowedHttpMethods, addCurrencyApiConfig } from '../../../apiList'

const getCurrencyDetails = async (): Promise<GetAddCurrencyType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: addCurrencyApiConfig.getInitDataApi,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const addCurrencyDetails = async ({
  currenyType,
  inrAmount,
}: {
  currenyType: string
  inrAmount: number
}): Promise<number | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: addCurrencyApiConfig.addCurrencyDetails,
    method: AllowedHttpMethods.post,
    params: {
      currenyType,
      inrAmount,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const editAddCurrencyDetails = async (
  editAddCurrency: GetUpdatedCurrencyDetails,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: addCurrencyApiConfig.updateCurrencyDetails,
    method: AllowedHttpMethods.put,
    params: editAddCurrency,
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const addCurrencyListApi = {
  getCurrencyDetails,
  addCurrencyDetails,
  editAddCurrencyDetails,
}
export default addCurrencyListApi
